import I18N from 'i18n-js';
const I18n = window.I18n || I18N;
I18n.translations || (I18n.translations = {});
I18n.translations["es"] = I18n.extend((I18n.translations["es"] || {}), {
  "autoflow": {
    "add": "Añadir",
    "next": "Siguiente"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Trabajo de Facebook guardado con éxito"
      },
      "google": {
        "fill_out": "Complete todos los datos requeridos en la Configuración de la campaña",
        "save_success": "Google Jobs se guardó correctamente"
      },
      "landing_page": {
        "add_url": "Agregar un URL",
        "cancel": "Cancelar",
        "custom_landing_page_description": "Genere nuevas URL y asigne una fuente por URL. Los candidatos que completen la preselección en la URL serán rastreados con la fuente personalizada. Los nombres de fuentes comunes son el nombre del sitio y el nombre del reclutador asignado, el nombre del evento.",
        "custom_landing_page_title": "Personalizar la fuente de la página de destino",
        "custom_source_label": "Nombre de la Fuente",
        "date_created": "Creada",
        "invalid_url": "URL de redireccionamiento no válido",
        "landing_pages": "Páginas de destino",
        "landing_pages_desc": "Por defecto, la página de destino se registra como \"Landing Page\" en el punto de datos de origen. Abajo, puede nombrar una URL de página de destino como fuente personalizada.",
        "redirect_after": "Redirigir Después",
        "redirect_url": "Enlace de redireccionamiento",
        "refresh_rate_min_error": "La frecuencia de actualización debe ser de al menos 1 segundo",
        "reload_redirect": "Redirigir Después",
        "save_success": "La página de destino se guardó con éxito",
        "seconds": "Segundos",
        "source_placeholder": "Ej. Sitio en Washington ",
        "source_title": "Fuente Personalizada",
        "url_copy": "URL copiada al portapapeles"
      },
      "messenger": {
        "copy_url": "Copiar URL",
        "create_messenger_source_url": "Crear URL",
        "create_messenger_source_url_success": "URL de Messenger fue creado exitosamente",
        "default_input_source_value": "Fuente",
        "default_select_option_value": "Seleccionar...",
        "facebook_pages": "Páginas de Facebook",
        "messenger_link": "Link de Messenger",
        "messenger_source_url_description": "Los candidatos que usen este URL de Messenger serán rastreados con esta fuente.",
        "messenger_source_url_title": "Rastrear fuente personalizada en un URL de Messenger",
        "page_title": "Pagina de Facebook",
        "previously_created_messenger_urls": "URLs de Messenger creados previamente",
        "previously_created_messenger_urls_description": "Aquí están todos los URL de Messenger creados previamente para esta campaña",
        "select_pages": "Seleccione las páginas de Facebook que le gustaría que muestren esta campaña en Messenger. Luego, haga clic en \"Guardar\" para aplicar los cambios",
        "source_label": "Fuente",
        "source_title": "Rastrea una fuente personalizada"
      },
      "tecoloco_jobs": {
        "fill_out": "Complete todos los datos requeridos en la Configuración de la campaña",
        "save_success": "Trabajos de Tecoloco guardados con éxito"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Tipo de Posición",
        "job_type_options": {
          "contract": "Contrato",
          "fixed_term": "Término fijo",
          "full_time": "Tiempo Completo",
          "internship": "Practicas",
          "part_time": "Medio Tiempo",
          "probationary": "De prueba",
          "project": "Proyecto",
          "regular": "Regular",
          "seasonal": "Estacional",
          "volunteer": "Voluntarios"
        },
        "location": "Ubicación",
        "salary": "Salario"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Compartir"
        }
      }
    },
    "buttons": {
      "proceed": "Proceder",
      "submit": "Envíar"
    },
    "labels": {
      "no_results": "Datos no disponibles"
    },
    "options": {
      "deleted": "Eliminados",
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATSAPP"
    },
    "toastr": {
      "actions": {
        "failed": "Esta acción no se procesó correctamente.",
        "success": "Esta acción se procesó correctamente."
      }
    },
    "upload": "Subir"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "Administrador"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "dom",
      "lun",
      "mar",
      "mié",
      "jue",
      "vie",
      "sáb"
    ],
    "abbr_month_names": [
      null,
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic"
    ],
    "day_names": [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%-d/%-m/%Y",
      "long": "%-d de %B de %Y",
      "short": "%-d de %b"
    },
    "month_names": [
      null,
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "alrededor de 1 hora",
        "other": "alrededor de %{count} horas"
      },
      "about_x_months": {
        "one": "alrededor de 1 mes",
        "other": "alrededor de %{count} meses"
      },
      "about_x_years": {
        "one": "alrededor de 1 año",
        "other": "alrededor de %{count} años"
      },
      "almost_x_years": {
        "one": "casi 1 año",
        "other": "casi %{count} años"
      },
      "half_a_minute": "medio minuto",
      "less_than_x_minutes": {
        "one": "menos de 1 minuto",
        "other": "menos de %{count} minutos"
      },
      "less_than_x_seconds": {
        "one": "menos de 1 segundo",
        "other": "menos de %{count} segundos"
      },
      "over_x_years": {
        "one": "más de 1 año",
        "other": "más de %{count} años"
      },
      "x_days": {
        "one": "1 día",
        "other": "%{count} días"
      },
      "x_minutes": {
        "one": "1 minuto",
        "other": "%{count} minutos"
      },
      "x_months": {
        "one": "1 mes",
        "other": "%{count} meses"
      },
      "x_seconds": {
        "one": "1 segundo",
        "other": "%{count} segundos"
      }
    },
    "prompts": {
      "day": "Día",
      "hour": "Hora",
      "minute": "Minutos",
      "month": "Mes",
      "second": "Segundos",
      "year": "Año"
    }
  },
  "eos": {
    "campaign": {
      "applicant_scoring": {
        "applicant_scoring": {
          "add": "Añadir",
          "candidate_attribute": "Atributo del candidato",
          "description": "Seleccione Atributos de Candidato y asigne un porcentaje de peso a cada uno para un total del 100% hacia el Puntaje de Lead para esta campaña.",
          "dropdown_hint": "Seleccione un atributo de la lista",
          "title": "Calificación de Leads",
          "weight": "Peso"
        },
        "description": "Configure un Sistema de Calificación para esta campaña asignando un peso a cada Atributo de Candidato (Geolocalización, Nivel de Inglés de TalkScore y preguntas de Opción Múltiple), y luego configure una puntuación para los elemento dentro de esos parámetro. ",
        "error": "La Calificación de Leads no se guardó. Por favor intente de nuevo. ",
        "item_scoring": {
          "candidate_attribute": "Atributo del candidato",
          "description": "Configure un parámetro de calificación para cada elemento de 0 a 100%. En este caso, un 100% significa que un candidato con ese parámetro obtendrá la puntuación total asignada en. la pestaña de Calificación de Leads. ",
          "empty": "Aún no se han configurado Atributos de Candidato. Agregue atributos y asígneles un peso primero en la pestaña de Calificación de Leads. ",
          "hint": {
            "geolocation": "Distancia de la ubicación de Campaña configurada en Ajustes. ",
            "multiple": "Para editar estos elementos debe ingresar a la pestaña de Preguntas y modificar las opciones directamente. ",
            "talkScore": ""
          },
          "items": "Elementos y Parámetros de Calificación",
          "title": "Calificación de ítems",
          "value_label": {
            "geopoint": "Dentro de"
          }
        },
        "shared": {
          "cancel": "Cancelar",
          "candidate": "Atributo del candidato",
          "save": "Guardar"
        },
        "success": "La Calificación de Leads se guardó con éxito. ",
        "title": "Calificación de Leads",
        "weight_error": "La distribución del peso debe sumar 100%"
      },
      "label": {
        "add_button": "Agregar un botón",
        "banner": "Banner\n",
        "call_to_action": "Llamado a la Acción",
        "cancel": "Cancelar",
        "completion_message": "Mensaje de Finalización\n",
        "copy": "Copiar",
        "create_button": "Crear botón",
        "crop": "Recortar",
        "facebook_pixel_id": "ID de Facebook Pixel ",
        "google_tag_container_id": "ID del contenedor del administrador de etiquetas de Google",
        "landing_page_type": "Tipo de Página de Destino",
        "landing_page_url": "URL del Landing Page",
        "new_landing_page_design": "Nueva Página de Destino",
        "redirect_url": "Enlace de redireccionamiento",
        "text_displayed": "Texto desplegado"
      },
      "talkscore": {
        "weight_distribution": {
          "description": "TalkScore permite calificar respuestas de audio en inglés. Se calcula usando 5 elementos: Fluidez, Gramática, Pronunciación, Vocabulario y Relevancia. Respuestas no relevantes no serán consideradas de manera automática. Aquí se puede modificar el peso de los primeros 4 factores para reflejar sus prioridades y preferencias.",
          "error": "La configuración de TalkScore no se guardó. Por favor intente de nuevo.",
          "subtitle": "Parámetros de Calificación",
          "success": "La configuración de TalkScore se guardó con éxito. ",
          "title": "Calificación de inglés"
        }
      },
      "text": {
        "active_cta_limit": "Se alcanzó el límite de botones activos. ",
        "add_cta": "Agregar botones de Llamado a la Acción a la Pantalla de Finalización",
        "add_cta_info": "Botones de Llamado a la acción en las Pantallas de finalización y así redirigir a los aplicantes a tus redes sociales o para realizar una acción. Puedes crear múltiples botones, pero solo tres pueden estar activos a la vez. ",
        "allowed_banner_files": "Tipos de archivos permitidos: jpg, png, jpeg. 2 MB Máx.",
        "apply_new_design": "Aplicar la nueva Página de Destino a esta campaña. ",
        "banner_notice": "Estás utilizando el Banner predeterminado en todas las campañas desde la Configuración de la Empresa. ",
        "banner_required": "Este campo es requerido.",
        "button_limit_reached": "Se alcanzó el límite de botones activos.",
        "click_on_dropdown": "Haz clic en el menú desplegable para leer más sobre cada tipo.",
        "custom_source_guide": "Por defecto, la página de destino se registra como \"Landing Page\" en el punto de datos de origen. Abajo, puede nombrar una URL de página de destino como fuente personalizada.",
        "default_banner_use": "Si no se agrega ningún banner y hay un Banner Predeterminado disponible en la Configuración de Empresa, se utilizará el Banner Predeterminado.",
        "incomplete_details": "Detalles incompletos.",
        "internal_server_error": "Lo sentimos, estamos experimentando problemas con nuestro servidor. Por favor, inténtelo de nuevo más tarde.",
        "invalid_url": "%{url} no es una URL válida. ",
        "landing_page_type": {
          "multiple": {
            "description": "Se muestran las preguntas una a la vez. ",
            "title": "Una Pregunta por Pantalla"
          },
          "single": {
            "description": "Todas las preguntas se muestran en una sola página. ",
            "title": "Formulario"
          }
        },
        "landing_pages": "Páginas de destino",
        "nothing_to_update": "Nada que actualizar.",
        "page_type_notice": "Ya has seleccionado el tipo %{type} para todas las campañas desde Configuración de la Empresa.",
        "recommended_banner": "2100px x 1100px recomendado.",
        "response_resubmit": {
          "disabled": "Deshabilite el botón Atrás para evitar reenvíos (no aplicable a las Campañas de Inducción)",
          "enabled": "Habilite el botón Atrás para permitir reenvíos (no aplicable a las Campañas de Inducción)"
        },
        "shown_end_form": "Se muestra al final del formulario.",
        "updated_successfully": "Actualizado con éxito."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color de Tema",
        "default_banner": "Banner Predeterminado",
        "landing_page_sop_up_screen": "Ventana emergente en la Página de Destino ",
        "primary": "Primario",
        "secondary": "Secundario",
        "shade": "Tono"
      },
      "listings": {
        "button": {
          "cancel": "Cancelar",
          "save": "Guardar",
          "upload": "Cargar"
        },
        "description": "Esta página es donde se muestran las Campañas de Aplicación de Trabajo seleccionadas, lo que permite a los candidatos ver sus ofertas de trabajo y postularse a través de sus respectivas páginas de destino.",
        "input": {
          "label": {
            "banner": "Banner",
            "banner_allowed_types": "Tipos de archivos permitidos: jpg, jpeg y png.",
            "banner_recommended_size": "1280px x 400px",
            "copied": "Copiado al portapapeles",
            "header_char_count": "%{count}/60 caracteres",
            "listings_url": "URL de la página de Listado de Vacantes",
            "page_header": "Encabezado de página"
          },
          "placeholder": {
            "page_header": "Buscar ofertas de trabajo en %{company}"
          }
        },
        "messages": {
          "error": "La configuración no se guardó. Por favor intente de nuevo. ",
          "success": "La configuración se guardó correctamente."
        },
        "page": {
          "button": {
            "apply": "Aplicar",
            "first": "Primera",
            "last": "Última",
            "search": "BUSCAR"
          },
          "input": {
            "keywords": "Palabras clave",
            "location": "Ubicación",
            "remote": "Remoto"
          },
          "label": {
            "default_header": "Buscar ofertas de trabajo en %{company}",
            "go_to_top": "Subir",
            "job_count": "Mostrando %{count} de %{total} trabajos",
            "no_results": "No hay resultados",
            "salary_undisclosed": "No revelado"
          },
          "source": "Lista de Vacantes"
        },
        "title": "Listado de Vacantes"
      },
      "text": {
        "apply_new_design": "Aplicar la nueva Página de Destino a todas las campañas.",
        "apply_page_type": "Aplicar el Tipo de Página de Destino a todas las campañas. Si se selecciona, la opción de modificar el tipo estará deshabilitada en la configuración de la campaña. ",
        "default_banner": "Si no se carga ningún banner en una campaña, se utilizará el Banner Predeterminado.",
        "default_banner_use": "Utilizar el Banner Predeterminado en todas las campañas. Si se selecciona, la opción se desactivará en la configuración de la campaña.",
        "enter_custom_color": "Alternativamente, puede ingresar valores de código HEX en los campos de texto Principal y Secundario.",
        "landing_page_sop_up_screen": "Esto se mostrará como una ventana emergente en las Páginas de Destino antes de que los candidatos ingresen su información personal.",
        "select_color_palette": "Seleccione los colores para el tema de color de la página de destino usando la paleta y los controles deslizantes a continuación."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "Correo electrónico",
        "errors": {
          "field_required": "%{field} es requerido."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Además del email, ¿Cuál es la mejor manera para notificarte los pasos a seguir?",
        "whatsapp": "WhatsApp"
      },
      "consent": "Este sitio solo utiliza cookies de sesión que son esenciales para poder navegar por el sitio y usar sus características y funcionalidades. Las cookies de sesión no recopilan datos de identificación personal.",
      "label": {
        "audio": "Audio",
        "click_download": "Haga click aquí para descargar",
        "continue": "Continuar",
        "contract": "Contrato",
        "copy_it": "Cópialo",
        "email": "Correo electrónico",
        "email_it": "Envíalo por Email",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "Subir archivo",
        "first_name": "Nombre",
        "fixed_term": "Término fijo",
        "full_time": "Tiempo Completo",
        "get_started": "Empezar",
        "internship": "Pasantía",
        "job_type": "Tipo de Posición",
        "last_name": "Apellidos",
        "location": "Ubicación",
        "new_recording": "Nueva grabación",
        "next": "Siguiente",
        "part_time": "Medio Tiempo",
        "pause": "Pausar",
        "phone_number": "Número de teléfono",
        "picture": "Imagen",
        "play": "Reproducir",
        "play_recording": "Reproducir grabación",
        "post_it": "Publícalo",
        "probationary": "De prueba",
        "proceed": "Proceder",
        "project": "Proyecto",
        "record_now": "Grabar ahora",
        "regular": "Regular",
        "retake_picture": "Volver a tomar foto",
        "retry": "Reintentar",
        "salary": "Salario",
        "save": "Guardar",
        "seasonal": "Temporal",
        "share": "Compartir",
        "share_it": "Compártelo",
        "snap_photo": "Tomar foto",
        "start_camera": "Iniciar Cámara",
        "start_recording": "Empezar a grabar",
        "stop": "Detener",
        "stop_recording": "Para de grabar",
        "submit": "Envíar",
        "take_picture": "Toma una foto",
        "text": "Texto",
        "tweet_it": "Tuitéalo",
        "undisclosed": "No revelado",
        "upload": "Cargar",
        "upload_time": "La carga del video puede demorar un tiempo, por favor espere.",
        "view_sample": "Ver muestra",
        "volunteer": "Voluntarios",
        "warning": "Alerta",
        "whatsapp": "WhatsApp",
        "your_progress": "Progreso"
      },
      "persistent_privacy_policy_link": {
        "click": "Haga clic <a target=\"_b\" href=\"https://talkpush.com/privacy/\">aquí</a> para leer su política de privacidad.",
        "info": "Utilizamos un servicio de terceros llamado Talkpush para ayudarnos a recopilar la información que necesitamos para evaluar a los solicitantes y tomar decisiones de contratación."
      },
      "text": {
        "about_company": "Acerca de %{company}",
        "about_our_company": "Sobre nuestra compañía",
        "application_invalid": "Aplicación  no válida",
        "camera_not_permitted": "El acceso a la cámara está bloqueado.",
        "close_warning": "En caso de abandonar este cuestionario antes de enviarlo, podrá completarlo en un intento posterior, pero ninguna respuesta/registro previo será visible o editable.",
        "completion_message": "Has completado y enviado con éxito tu aplicación para %{job}. ¡Gracias!",
        "contact_channel": "¿Cuál es la mejor manera de contactarme? ",
        "copied_succesfully": "Copiado con éxito",
        "dropdown_instruction": "Selecciona una opción",
        "generic_browser_error": "No se puede grabar multimedia. Asegúrate de que haya un dispositivo de captura de multimedia y que estés utilizando el navegador actualizado para tener la mejor experiencia. ",
        "instructions": "Instrucciones: %{text}",
        "invalid_location": "Ingrese una ubicación válida.",
        "job_type_options": {
          "contract": "Contrato",
          "default": "Aplicar para conocer el tipo de trabajo",
          "fixed_term": "Término fijo",
          "full_time": "Tiempo Completo",
          "internship": "Pasantía",
          "part_time": "Medio Tiempo",
          "probationary": "De prueba",
          "project": "Proyecto",
          "regular": "Regular",
          "seasonal": "Temporal",
          "volunteer": "Voluntarios"
        },
        "mic_not_permitted": "El acceso al micrófono está bloqueado.",
        "min_max_char": "La respuesta debe contener entre %{min} y %{max} caracteres. ",
        "no_camera": "No hay cámara disponible.",
        "no_media_device": "Ningún dispositivo multimedia accesible.",
        "no_mic": "No hay micrófono disponible.",
        "no_supported_mimetype": "No hay ningún tipo de medio MIME admitido en este navegador y la calidad de la grabación puede verse afectada. Intenta cambiar a otro navegador o dispositivo.",
        "our_social_media": "Nuestras Redes Sociales",
        "play_media": {
          "answer": "Reproducido",
          "instruction": "Haga clic en reproducir para comenzar, luego haga clic en el botón 'siguiente' para pasar a la siguiente pregunta.",
          "local_storage_not_present": "Navegador no compatible"
        },
        "pop_up_privacy_policy": "Al hacer clic en Continuar, acepta la <a href=\"%{policy_url}\">Política de Privacidad</a> de %{company} y la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor de servicios. Esto marcará automáticamente la casilla en el formulario.",
        "privacy_policy": "Acepto y estoy de acuerdo con la  <a target=\"_b\" href=\"%{policy_url}\">Política de Privacidad</a> de %{company} y la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor del servicio.",
        "privacy_policy_talkpush": "Acepto la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor del servicio. ",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "processing_answers": "Por favor espera un momento mientras procesamos tus respuestas.",
        "question_progress": "%{current} de %{size}",
        "rate_your_experience": "Califica tu experiencia",
        "receive_updates": "Quiero recibir actualizaciones a través de SMS, Facebook, Messenger o WhatsApp.\n",
        "remote_types": {
          "fully_remote": "Totalmente Remoto",
          "temporarily_remote": "Temporalmente Remoto",
          "wfh_flexible": "Trabajo desde Casa Flexible"
        },
        "salary_types": {
          "annually": "Anual",
          "biweekly": "Quincenal",
          "daily": "Diario",
          "hourly": "Por hora",
          "monthly": "Mensual",
          "one-time": "Una vez",
          "weekly": "Semanal"
        },
        "share_with_network": "Comparte con tu red",
        "size_of_mb": "%{size} de 20mb",
        "talkscore_instructions": "Las grabaciones deben tener un mínimo de 30 segundos y un máximo de 1 minuto. Asegúrese de que el audio sea claro y que no haya sonidos de fondo. ",
        "thank_you": "Gracias",
        "trouble_playing_response": "¿Tiene problemas para reproducir esta respuesta?",
        "upload": {
          "error": "Algunos archivos no se pueden cargar.",
          "file_invalid_type": "El formato del archivo debe ser .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "El tamaño del archivo debe ser inferior a 10 MB."
        },
        "upload_failed": "Hubo un error al enviar su respuesta. Inténtalo de nuevo.",
        "video_limit": "La duración máxima de la respuesta de video es de 1 minuto."
      }
    },
    "message": {
      "label": {
        "delete": "Eliminar",
        "duplicate": "Duplicar",
        "edit": "Editar"
      },
      "template": {
        "caption": "El nombre de la plantilla lo ayudará a diferenciar las plantillas, así que hágalo único e identificable.",
        "character_count": "Caracteres restantes %{count} / %{limit}",
        "create_new": "Crear nueva",
        "description": "Configure plantillas de mensajes para todos los canales que se utilizarán en Autoflow, para acciones masivas, movimientos de carpetas y como respuestas rápidas en todas las etapas del proceso de contratación.",
        "email": {
          "name": "Nombre de la plantilla de correo electrónico",
          "subject_line": "Línea de asunto",
          "tab": "Correo electrónico",
          "title": "Plantillas de correo electrónico"
        },
        "input": {
          "search_bar": {
            "placeholder": "Buscar plantilla de mensaje"
          }
        },
        "messenger": {
          "name": "Nombre de la plantilla de Messenger",
          "tab": "Messenger",
          "title": "Plantillas de Messenger"
        },
        "sms": {
          "name": "Nombre de la plantilla de SMS",
          "tab": "SMS",
          "title": "Plantillas de SMS"
        },
        "text": {
          "approved_by_meta": "Aprobado por Meta",
          "created_by_admin": "Creado por un administrador",
          "created_on": "Creado en %{date} por %{name}",
          "last_edited_on": "Editado en %{date} por %{name}",
          "linked_campaigns_description": "Esta plantilla de mensaje se está utilizando para Flujos Automáticos en las siguientes campañas",
          "update_from_template": "Actualizar mensaje desde plantilla",
          "update_from_template_confirmation": "Este mensaje está actualmente vinculado a una plantilla. Si lo edita, se desvinculará de la Plantilla y cualquier otro cambio deberá realizarse manualmente en esta acción de Flujo automático, ya que ya no se le aplicará ninguna edición masiva de la Plantilla.",
          "update_template": "Actualizar plantilla de mensaje",
          "update_template_confirmation": "Al actualizar esta plantilla de mensaje, todas las acciones de flujo automático que la utilicen también se actualizarán. Quiere proceder?"
        },
        "title": "Plantillas de mensajes",
        "whatsapp": {
          "name": "Nombre de la plantilla de WhatsApp",
          "tab": "WhatsApp",
          "title": "Plantillas de WhatsApp"
        }
      },
      "tokens": {
        "aspiring_minds_assessment_link": {
          "description": "Enlace personalizado a la evaluación de Aspiring Minds",
          "title": "Enlace de evaluación de aspirantes"
        },
        "aspiring_minds_login_link": {
          "description": "Enlace personalizado para iniciar sesión en Aspiring Minds",
          "title": "Enlace de inicio de sesión de Aspiring Minds"
        },
        "aspiring_minds_password": {
          "description": "Contraseña de Aspiring Minds",
          "title": "Contraseña de Aspiring Minds"
        },
        "aspiring_minds_svar_url": {
          "description": "Enlace personalizado a la evaluación SVAR de Aspiring Minds",
          "title": "Enlace de evaluación SVAR de Aspiring Minds"
        },
        "aspiring_minds_username": {
          "description": "Nombre de usuario de Aspiring Minds",
          "title": "Nombre de usuario de Aspiring Minds"
        },
        "assigned_recruiter": {
          "description": "Nombre completo del reclutador asignado",
          "title": "Reclutador asignado"
        },
        "assigned_recruiter_calendar_scheduler_url": {
          "description": "Enlace para agendar en el calendario del gerente asignado",
          "title": "Enlace del calendario del reclutador asignado"
        },
        "button": {
          "name": "Tokens"
        },
        "calendar_date": {
          "description": "Fecha de la cita de mi calendario",
          "title": "Fecha calendario"
        },
        "calendar_time_end": {
          "description": "Fin de la cita de mi calendario",
          "title": "Fin de la cita"
        },
        "calendar_time_start": {
          "description": "Inicio de la cita de mi calendario",
          "title": "Hora de inicio de la cita"
        },
        "call_center_agent_assessment_url": {
          "description": "Enlace personalizado a la evaluación SHL para agente de call center",
          "title": "URL de la evaluación del agente del call center de SHL"
        },
        "call_center_agent_secondary_assessment_url": {
          "description": "Enlace personalizado a la evaluación secundaria de SHL Call Center Agent",
          "title": "URL de evaluación secundaria del agente del centro de llamadas de SHL"
        },
        "candidate_first_name": {
          "description": "Primer nombre del Candidato",
          "title": "Primer Nombre del Candidato"
        },
        "candidate_id": {
          "description": "ID de la aplicación del candidato",
          "title": "Identificación del candidato"
        },
        "candidate_name": {
          "description": "Nombre completo del Candidato",
          "title": "Nombre del Candidato"
        },
        "channel_optin_url": {
          "description": "Enlace a la página de suscripción de WhatsApp",
          "title": "URL de suscripción de WhatsApp"
        },
        "chat_attachment": {
          "description": "ID de chat personalizado para solicitar archivos por Messenger",
          "title": "Archivo adjunto de chat"
        },
        "choose_position_link": {
          "description": "Enlace personalizado para mostrar vacantes en Messenger",
          "title": "Elegir enlace de posición"
        },
        "city": {
          "description": "Ubicación de la vacante de la campaña",
          "title": "Ciudad de campaña"
        },
        "company": {
          "description": "Nombre de su empresa",
          "title": "Compañía"
        },
        "emmersion_sign_in_url": {
          "description": "Enlace de inicio de sesión para evaluaciones de Emmersion",
          "title": "Enlace de Emmersion"
        },
        "hireiq_assessment_link": {
          "description": "Enlace personalizado para la evaluación de Hire IQ",
          "title": "Enlace de Hire IQ"
        },
        "hireiq_pin": {
          "description": "Número de PIN de Hire IQ",
          "title": "PIN de Hire IQ"
        },
        "insert_picture": {
          "description": "Inserta una imagen para enviarla por correo electrónico o Messenger",
          "title": "Insertar imagen"
        },
        "insert_video": {
          "description": "Inserte un video para enviarlo por correo electrónico o Messenger",
          "title": "Insertar video"
        },
        "interview_page_url": {
          "description": "Enlace personalizado al formulario de la página de destino",
          "title": "Enlace de Entrevista"
        },
        "job_landing_page_url": {
          "description": "Enlace a la página de descripción del trabajo",
          "title": "URL de la página de destino del trabajo"
        },
        "job_title": {
          "description": "Vacante a la cual el candidato aplicó",
          "title": "Posición"
        },
        "mail_attachment": {
          "description": "ID de correo electrónico personalizado para solicitar archivos por correo electrónico",
          "title": "Archivo adjunto de correo"
        },
        "messenger_interview_link": {
          "description": "Enlace personalizado para desplegar las preguntas de la entrevista en Messenger",
          "title": "Link de messenger"
        },
        "my_calendar_scheduler_url": {
          "description": "Enlace a su calendario",
          "title": "Enlace de mi calendario"
        },
        "onboarding_form_url": {
          "description": "Enlace al formulario de incorporación en línea",
          "title": "Enlace del formulario de incorporación"
        },
        "onboarding_link": {
          "description": "Enlace al chatbot de incorporación",
          "title": "Enlace de inducción"
        },
        "pre_employment_chat_assessment_url": {
          "description": "Enlace personalizado a la evaluación SHL por chat",
          "title": "Enlace de la pre-evaluación SHL para el empleo por chat."
        },
        "reapply_retention_period": {
          "description": "Período de pausa de la campaña",
          "title": "Volver a aplicar el período de retención"
        },
        "recruiter_first_name": {
          "description": "Primer nombre del reclutador asignado",
          "title": "Nombre de Reclutador Asignado"
        },
        "referee": {
          "description": "Nombre de la persona que refirió a un candidato",
          "title": "Referido"
        },
        "rejected_reasons": {
          "description": "Razones para rechazar al candidato",
          "title": "Razones de rechazo"
        },
        "scheduled_at": {
          "description": "Fecha programada para la entrevista del candidato",
          "title": "Fecha Entrevista:"
        },
        "scheduler_url": {
          "description": "Enlace al calendario del centro de reclutamiento de las campañas",
          "title": "Link para agendar cita"
        },
        "shortlisted_reasons": {
          "description": "Razones para preseleccionar al candidato",
          "title": "Razones de Preselección"
        },
        "site_location": {
          "description": "Sitio de la empresa o sucursal donde se asignará o capacitará a la nuevos contratados.",
          "title": "Ubicación"
        },
        "training_batch": {
          "description": "Grupo u ola de aprendices para su incorporación",
          "title": "Grupo de entrenamiento"
        },
        "training_date": {
          "description": "Fecha de la capacitación como parte de su incorporación",
          "title": "Fecha de entrenamiento"
        },
        "training_program": {
          "description": "Clase o programa de capacitación para su incorporación",
          "title": "Programa de Entrenamiento"
        },
        "training_time": {
          "description": "Tiempo de la capacitación para su incorporación",
          "title": "Tiempo de entrenamiento"
        },
        "training_venue": {
          "description": "Lugar de la capacitación para su incorporación",
          "title": "Lugar de entrenamiento"
        },
        "upcoming_scheduled_appointment": {
          "description": "La próxima fecha programada para la entrevista del candidato",
          "title": "Próxima cita programada"
        }
      }
    },
    "prompt": {
      "label": {
        "add_a_question": "Agregar pregunta",
        "create_new": "Crear nueva",
        "delete": "Eliminar",
        "question_set": {
          "name": "Nombre de Set de Preguntas",
          "search": "Buscar Set de Preguntas",
          "send": "Enviar Set de Preguntas"
        }
      },
      "text": {
        "created_by": "Creado por %{name} el %{date}",
        "edited_by": "Editado por %{name} el %{date}",
        "question_set": {
          "cannot_be_deleted": "Este Set de Preguntas no puede ser eliminado ya que se utiliza en un Flujo Automático en las siguientes Campañas:",
          "description": "Configure Sets de Preguntas a partir de Plantillas para ser utilizados con Flujos Automáticos y así enviar Preguntas de Seguimiento a Candidatos en cualquier momento de su proceso. ",
          "name_description": "Este nombre te ayudará a identificar el Set de Preguntas al configurar un Flujo Automático. Recomendamos que sea un nombre único y fácil de identificar. ",
          "title": "Sets de Preguntas"
        }
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Correo electrónico",
        "first_name": "Nombre",
        "last_name": "Apellidos",
        "new_recording": "Nueva grabación",
        "phone_number": "Número de teléfono",
        "record_now": "Grabar ahora",
        "start_camera": "Iniciar Cámara",
        "stop_recording": "Para de grabar",
        "take_picture": "Toma una foto"
      },
      "notes": {
        "video_limit": "La duración máxima de la respuesta de video es de 1 minuto."
      },
      "show": {
        "about": "Acerca de"
      },
      "success": {
        "answers_message": "Gracias por enviar sus respuestas. Hemos recibido su aplicación.",
        "title": "Gracias"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Añadir imagen",
      "apply": "Aplicar",
      "change_image": "Cambiar imagen",
      "save": "Guardar",
      "select_page_helper": "Ligar una o más páginas de Facebook significa que cualquiera que hable con su bot puede ver esta campaña. Para que esta campaña no aparezca en el chatbot, deje este campo vacío.",
      "view_job_description": "Ver descripción"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "mejores prácticas",
        "first": "Las posiciones que se indicen en Google aparecerán directamente en los resultados de búsqueda de Google.",
        "head": "Habilitar que Google indice el Landing Page",
        "help_center": "nuestro centro de ayuda",
        "second": "Los aplicantes que accedan a estos resultados en Google serán redirigidos al Landing page de Talkpush, donde pueden aplicar y completar inmediatamente las preguntas iniciales. Puede aprender más al respecto en",
        "third": "Si su puesto de trabajo no aparece en las publicaciones de Google Job, por favor asegúrese de seguir estas"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Require que se completen el título, el país, y la descripción larga de la posición."
      }
    },
    "landing": {
      "copy": "Copiar",
      "first": "URL del Landing Page",
      "save": "Guardar"
    },
    "tecoloco": {
      "job_par": {
        "first": "Los trabajos que se enumeran en Tecoloco aparecerán enlos resultados de búsqueda de Tecoloco.",
        "head": "Anunciar este puesto de trabajo en Tecoloco",
        "help_center": "nuestro centro de ayuda",
        "second": "Los candidatos que se postulan para estas posiciones de trabajo son redirigidos a la página de Talkpush, donde pueden postularse y completar de inmediato las preguntas de selección. Puede obtener más información al respecto en"
      },
      "tecoloco_jobs": "Empleos en Tecoloco"
    }
  },
  "job_landing_page": {
    "application_invalid": "Aplicación inválida"
  },
  "jobs": {
    "salary_types": {
      "annually": "Anual",
      "biweekly": "Quincenal",
      "daily": "Diariamente",
      "hourly": "Por hora\n",
      "monthly": "Mensual",
      "one-time": "Una vez",
      "weekly": "Semanal"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "mil millones",
          "million": "Millón",
          "quadrillion": "mil billones",
          "thousand": "mil",
          "trillion": "Trillón",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n %",
        "precision": 1
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
  "setup_questions": {
    "question_types": {
      "audio": "Audio",
      "text": "Texto"
    },
    "update": "Actualizar"
  },
  "time": {
    "am": "am",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%A, %-d de %B de %Y %H:%M:%S %z",
      "long": "%-d de %B de %Y %H:%M",
      "short": "%-d de %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "pm"
  }
});

window.t = I18n.t.bind(I18n);
window.l = I18n.l.bind(I18n);
I18n.locale = document.documentElement.lang;
